import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import './RyanAdminHeader.css';

interface RyanAdminHeaderProps {
  title: string;
  subtitle: string;
}

/**
 * Renderizado via portal direto em document.body — evita qualquer chance de
 * um ancestral (transform/filter/animation) virar containing block e quebrar
 * o position:fixed, o que fazia o header "descer" junto com o scroll.
 */
const RyanAdminHeader: React.FC<RyanAdminHeaderProps> = ({ title, subtitle }) => {
  const navigate = useNavigate();

  return ReactDOM.createPortal(
    <header className="ryan-admin-header">
      {/* Mesma caixa (max-width 1100px, centralizada, padding 32px) usada
          pelo conteúdo de cada aba — garante alinhamento pixel-perfeito das
          bordas laterais com os cards/abas/tabelas abaixo. */}
      <div className="ryan-admin-header-inner">
        <div className="ryan-admin-header-page">
          <h2 className="ryan-admin-header-page-title">{title}</h2>
          <p className="ryan-admin-header-page-subtitle">{subtitle}</p>
        </div>

        <div className="ryan-admin-header-brand">
          <h1 className="ryan-admin-header-brand-title">
            <span>Painel</span>
            <span>Administrativo</span>
          </h1>
          <button
            className="ryan-admin-header-logo-btn"
            onClick={() => navigate('/ryan')}
            title="Voltar para o início"
          >
            <img src="/Ryan/graia-logo-verde.png" alt="Graia Medicina" className="ryan-admin-header-logo" />
          </button>
        </div>
      </div>
    </header>,
    document.body
  );
};

export default RyanAdminHeader;
